// extracted by mini-css-extract-plugin
export default {"formText":"customAvatarList_formText__RrVOA","CustomSearchBar":"customAvatarList_CustomSearchBar__LwY5y","searchIcon":"customAvatarList_searchIcon__sROde"};